<template>
  <div class="box-border has-background-white h-100-per">
    <div class="mg-b-5 line-title-dh is-flex is-justify-spacebetween mg-b-25">
      <b-tooltip
        label="Move"
        type="is-dark"
        v-if="user.userLevel == 0"
        position="is-bottom"
      >
        <p
          class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
        >
          {{ $t("dashboard.mainDashboardBusinessInformation") }}
        </p>
      </b-tooltip>
      <p
        v-else
        class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
      >
        {{ $t("dashboard.mainDashboardBusinessInformation") }}
      </p>
      <div class="is-flex is-justify-end">
        <p
          v-if="getRule == 'startup'"
          class="pd-y-10 icon-color is-size-5 mg-r-10 cr-pointer"
          @click="$emit('ModalEdit'), $store.commit('setModalActive', true)"
        >
          <i class="fas fa-pen"></i>
        </p>
        <p
          class="pd-y-10 icon-color is-size-5 cr-pointer"
          @click="$emit('openModalInfo', 'bi-in')"
        >
          <i class="fas fa-question-circle"></i>
        </p>
      </div>
    </div>
    <div class="columns m-h-auto">
      <div class="column is-narrow">
        <div
          class="box pd-x-0 pd-y-0"
          style="
            width: 200px;
            border: 0;
            -webkit-box-shadow: none;
            box-shadow: none;
          "
        >
          <figure class="image mg-x-auto">
            <img
              style="
                -webkit-box-shadow: 0 2px 3px rgb(10 10 10 / 10%),
                  0 0 0 1px rgb(10 10 10 / 10%);
                box-shadow: 0 2px 3px rgb(10 10 10 / 10%),
                  0 0 0 1px rgb(10 10 10 / 10%);
                border-radius: 6px;
              "
              alt="profile pic"
              @error="
                $event.target.src =
                  'https://bulma.io/images/placeholders/128x128.png'
              "
              :src="imgUrl + srcImg"
            />
          </figure>
        </div>
      </div>
      <div class="column">
        <div class="">
          <p class="is-size-6 pd-y-5">
            <span class="has-text-grey">
              <i class="fas fa-address-book mg-r-8"></i>
            </span>
            <span class="th has-text-weight-normal">
              {{
                getRule === "startup"
                  ? user.organizeName
                  : userDetail.organizeName
              }}
            </span>
            <sup class="th pd-l-5">
              {{
                getRule === "startup" ? user.bizGroup : userDetail.bizGroup
              }}
              |
              {{
                getRule === "startup" && user.bizModel == 1
                  ? "Manufacturing (ธุรกิจผลิต)"
                  : "Services (ธุรกิจบริการ)"
              }}
              {{
                getRule !== "startup" && userDetail.bizModel == 1
                  ? "Manufacturing (ธุรกิจผลิต)"
                  : getRule !== "startup" && userDetail.bizModel == 2
                  ? "Services (ธุรกิจบริการ)"
                  : ""
              }}
            </sup>
          </p>
          <p class="is-size-7 pd-y-5">
            <span class="th pd-l-5">
              {{ getRule === "startup" ? user.address : userDetail.address }}
            </span>
          </p>
          <p class="is-size-7 th">
            <span
              class="th pd-l-5"
              v-if="
                (getRule === 'startup' && user.subDistrict != '') ||
                (getRule !== 'startup' && userDetail.subDistrict != '')
              "
            >
              {{
                getRule === "startup"
                  ? user.subDistrict
                  : userDetail.subDistrict
              }},
            </span>
            <span
              class="th pd-l-5"
              v-if="
                (getRule === 'startup' && user.cityDistrict != '') ||
                (getRule !== 'startup' && userDetail.cityDistrict != '')
              "
              >{{
                getRule === "startup"
                  ? user.cityDistrict
                  : userDetail.cityDistrict
              }},</span
            >
            <span
              class="th pd-l-5"
              v-if="
                (getRule === 'startup' && user.province != '') ||
                (getRule !== 'startup' && userDetail.province != '')
              "
              >{{
                getRule === "startup" ? user.province : userDetail.province
              }},</span
            >
            <span
              class="th pd-l-5"
              v-if="
                (getRule === 'startup' && user.postcode != '') ||
                (getRule !== 'startup' && userDetail.postcode != '')
              "
              >{{
                getRule === "startup" ? user.postcode : userDetail.postcode
              }}</span
            >
            <span
              class="th pd-l-5"
              v-if="
                (getRule === 'startup' && user.country != '') ||
                (getRule !== 'startup' && userDetail.country != '')
              "
              >{{
                getRule === "startup" ? user.country : userDetail.country
              }}</span
            >
          </p>
          <p class="is-size-6 pd-y-5">
            <span
              class="has-text-grey"
              v-if="
                (getRule === 'startup' && user.telephoneBusinessTeam) ||
                (getRule !== 'startup' && userDetail.telephoneBusinessTeam)
              "
            >
              <i class="fas fa-phone mg-r-8"></i>
            </span>
            <small
              class="th pd-5"
              v-if="
                (getRule === 'startup' && user.telephoneBusinessTeam) ||
                (getRule !== 'startup' && userDetail.telephoneBusinessTeam)
              "
              >{{
                getRule === "startup"
                  ? user.telephoneBusinessTeam
                  : userDetail.telephoneBusinessTeam
              }}</small
            >
            <small
              class="th pd-l-5 has-text-grey"
              v-if="
                (getRule === 'startup' && user.websiteBusiness) ||
                (getRule !== 'startup' && userDetail.websiteBusiness)
              "
            >
              <i class="fas fa-globe-asia mg-r-8"></i>
            </small>
            <span
              class="th"
              v-if="
                (getRule === 'startup' && user.websiteBusiness) ||
                (getRule !== 'startup' && userDetail.websiteBusiness)
              "
              >{{
                getRule === "startup"
                  ? user.websiteBusiness
                  : userDetail.websiteBusiness
              }}</span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    getRule() {
      return this.$store.getters.getRule;
    },
    user() {
      return this.$store.state.user;
    },
    userDetail() {
      return this.$store.state.userDetail;
    },
    srcImg() {
      return this.getRule === "startup"
        ? this.user.organizeLogo
        : this.userDetail.organizeLogo;
    },
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMAGE_URL,
      ModalInfomation: false,
    };
  },
};
</script>
<style scoped>
.column {
  padding: 8px 15px !important;
}
.box-circle-profile {
  width: 100%;
}
</style>